import { useEffect, useMemo, useState } from 'react';
import { getGameList } from '@op/services/game';
import { upperAndLowerFuzzyQuery } from '../utils';

export default function useGameList({
  platformSelect,
  searchValue,
}: {
  platformSelect?: Array<string>;
  searchValue: string;
}) {
  const [gameList, setGameList] = useState<Array<any>>([]);

  const toServerGetGameInfo = () => {
    return getGameList({}).then((data: any) => {
      setGameList(data || []);
    });
  };

  // 获取所有列表
  useEffect(() => {
    toServerGetGameInfo();
  }, []);

  const gameSelectOptions = useMemo(() => {
    let result = gameList;
    if (platformSelect) {
      if (platformSelect.length > 0 && platformSelect.length < 3) {
        result = gameList.filter((item) =>
          platformSelect.includes(item.entity_type),
        );
      }
    }
    return result.map((item) => ({
      text: item.entity_name,
      value: item.edition_unified_id,
    }));
  }, [gameList, platformSelect]);

  const selectOptions = useMemo(() => {
    return upperAndLowerFuzzyQuery(gameSelectOptions, searchValue);
  }, [gameSelectOptions, searchValue]);

  return { gameOptions: selectOptions, basicOptions: gameSelectOptions };
}
